import React, {useContext, useEffect, useState} from 'react';
import UserForm from '../../views/user/user-form';
import UserTable from '../../views/user/user-table';
import PermissionTabs from '../../views/permission';
import {useIntl} from 'react-intl';
import useAlerts from '../../hooks/use-alerts';
import {ModalContext} from '../../apiContexts';
import useStore from '../../hooks/use-store';
import useServices from '../../hooks/use-services';

const UserContainer = (props) => {
    const {store} = useStore();
    const {userService} = useServices();
    const {auth, coordinateFormats, azulPayStore, session, fullControlStore} = store;
    const intl = useIntl();
    const {toast} = useAlerts();
    const {showModalLoading, isModalLoading} = useContext(ModalContext);
    const [view, setView] = useState('userList');
    const [users, setUsers] = useState([]);
    const [coordFormats, setCoordinateFormats] = useState([]);
    const [data, setData] = useState({});
    const [customer, setCustomer] = useState({});
    const [selectedUser, setSelectedUser] = useState(null);
    const [azulPayErrors, setAzulPayErrors] = useState(null);


    useEffect(() => {
        (async () => {
            const users = await userService.list();
            users.sort((a, b) => a.name.localeCompare(b.name));
            setUsers(users);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const items = [];
            coordinateFormats.formats.map((type) => {
                items.push({id: type.key, title: type.name});
            });
            setCoordinateFormats(items);
        })();
    }, []);

    const userForm = async (data) => {
        const user = Object.keys(data).length ? data : {};
        setCustomer({});
        if (data.attributes) {
            if (data.attributes.hasOwnProperty('billingProvider')) {
                if (data.attributes.billingProvider === 'SENIOR') {
                    setCustomer({
                        cpf_cnpj: data.attributes.cpf_cnpj,
                        address: data.attributes.address,
                        city: data.attributes.city,
                        state: data.attributes.state,
                        zipcode: data.attributes.zipcode,
                        number: data.attributes.number,
                        neighborhood: data.attributes.neighborhood,
                    });
                }
            } else if (data.attributes.hasOwnProperty('customerId')) {
                const customer = await azulPayStore.getCustomerById(data.attributes.customerId);
                setCustomer(customer);
            }
        }

        setData(user);
        setView('userForm');
    };

    const newRegister = async (data) => {
        try {
            showModalLoading(true);
            const customer = createCustomer(data);
            delete data.customer;
            let result;
            if (customer) {
                const attributes = data.attributes || {};

                if (attributes.customerType === 'TT' && !attributes.hasOwnProperty('customerId')) {
                    const resultCostumer = await azulPayStore.createCustomer(customer);
                    attributes.customerId = resultCostumer.id;
                }

                data.attributes = attributes;
            }
            result = await userService.save(data);

            setUsers([...users, result]);
            setView('userList');
            toast.success(intl.formatMessage({id: 'sharedSavedSuccess'}));
        } catch (e) {
            console.log(e);
            if (e.azulPayErrors) {
                setAzulPayErrors(e.azulPayErrors);
            }
            toast.errorStatus(e);
        } finally {
            showModalLoading(false);
        }
    };

    const createCustomer = (data) => {
        if (data.customer) {
            const customer = Object.assign({}, data.customer);

            customer.email = data.email;
            customer.phone_number = data.phone;
            customer.full_name = data.name;

            return customer;
        }
        return null;
    };

    const updateRegister = async (data, afterTo = 'userList') => {
        console.log(data);
        try {
            showModalLoading(true);
            const index = users.findIndex(({id}) => id === data.id);
            const customer = createCustomer(data);

            delete data.customer;
            delete data.azulPayLinkType;
            delete data.customerDependentId;

            if (!data.attributes.hasOwnProperty('billingProvider')) {
                if (customer && customer.id) {
                    const resultCostumer = await azulPayStore.updateCustomer(customer);
                    data.attributes.customerId = resultCostumer.id;
                } else {
                    const attributes = data.attributes || {};

                    if (attributes.customerType === 'TT' && !attributes.hasOwnProperty('customerId')) {
                        const resultCostumer = await azulPayStore.createCustomer(customer);
                        attributes.customerId = resultCostumer.id;
                    }

                    data.attributes = attributes;
                }
            }

            const result = await userService.update({...users[index], ...data});
            users.splice(index, 1, result);
            setUsers([...users]);
            setView(afterTo);
            toast.success(intl.formatMessage({id: 'sharedUpdatedSuccess'}));
        } catch (e) {
            if (e.azulPayErrors) {
                setAzulPayErrors(e.azulPayErrors);
            }
            toast.errorStatus(e);
        } finally {
            showModalLoading(false);
        }
    };

    const removeRegister = async (data) => {
        try {
            showModalLoading(true);
            await userService.remove(data.id);
            setUsers(users.filter(({id}) => id !== data.id));
            setView('userList');
            toast.success(intl.formatMessage({id: 'sharedRemovedSuccess'}));
        } catch (e) {
            toast.errorStatus(e);
        } finally {
            showModalLoading(false);
        }
    };

    const showPermissionTabs = (data) => {
        setSelectedUser({userId: data.id});
        setView('userPermissions');
    };

    const getStates = () => {
        const data = [];
        const states = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

        states.map( (state) => {
            data.push({id: state, title: state});
        });

        return data;
    };

    return (
        <>
            {
                {
                    userList: (
                        <UserTable
                            list={users}
                            userForm={userForm}
                            removeRegister={removeRegister}
                            permissions={showPermissionTabs}
                            loading={isModalLoading}
                            intl={intl}
                        />
                    ),
                    userForm: (
                        <UserForm
                            cancel={() => setView('userList')}
                            data={Object.assign({}, data)}
                            session={session}
                            profile={auth.profile}
                            states={getStates()}
                            coordinateFormats={coordFormats}
                            edit={Object.keys(data).length}
                            newRegister={newRegister}
                            updateRegister={updateRegister}
                            loading={isModalLoading}
                            customer={Object.keys(data).length ? customer : {}}
                            fullControlStore={fullControlStore}
                            azulPayErrors={azulPayErrors}
                        />
                    ),
                    userPermissions: (
                        <PermissionTabs
                            options={[
                                'device',
                                'notification',
                                'geofence',
                                'group',
                                'calendar',
                                'driver',
                                'maintenance']}
                            data={selectedUser}
                            cancel={() => setView('userList')}/>
                    ),
                }[view]
            }
        </>
    );
};


export default UserContainer;
